import { makeExportAction } from "src/actions/makeExportAction"

export const ExportAction = ({ onExport }) =>
  makeExportAction({ noun: "contract", onExport })
